<template>
  <div v-if="activity">
    <span><b>{{ activity.dateFrom }}:</b>&nbsp;</span>
    <span>{{ activity.type }}&nbsp;</span>
    <span v-if="!forOpp"><i>({{ activity.owner.firstName }} {{ activity.owner.lastName }})</i></span>
    <span v-else><i>({{ activity.relatedTo.firstName }} {{ activity.relatedTo.lastName }})</i></span>
  </div>
</template>

<script>
export default {
  props: {
    activity: {
      type: Object,
      default: () => null
    },
    forOpp: {
      type: Boolean,
      default: false
    }
  }
}
</script>
